.changeSelectRow {
	margin-top: 3px;
}

.changeSelectRowNewGrid {
	margin-top: 0px;
}
